// 停车相关变量
// 停车目标箭头：长度3，箭头头部长度0.5，宽度0.5
export const arrowLength = 3;
export const headLength = 0.5;
export const headWidth = 0.5;

// 矩形框：长3，宽1.5
export const rectLocal: Array<{ x: number; y: number }> = [
  { x: 1.5, y: 0.5 },
  { x: 1.5, y: -0.5 },
  { x: -0.5, y: -0.5 },
  { x: -0.5, y: 0.5 },
];

// DPR 上限：过高会增加纹理更新开销和显存占用；2 通常足够解决模糊问题。
export const TRAFFIC_LIGHT_LABEL_DPR_MAX = 2;
